<template>
  <v-app>
    <v-toolbar app dark color="black">
      <v-btn icon @click="$router.back()"><v-icon>arrow_back</v-icon></v-btn>
      <router-link to="/" style="display: inherit" class="justify-center">
        <img :src="require('../assets/FullNameLogo.png')" alt="Score Book" :height="35">
      </router-link>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card class="round">
              <v-card-text>
                <router-view></router-view>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
    export default {
        name: "FormLayout"
    }
</script>

<style scoped>
  .round {
    border-radius: 0.75rem;
  }
</style>
